import { Component, Inject, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { StatusApprovalsPipe } from '@fuse/pipes/approvals-status/status-translate.pipe';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { TranslateService } from '@ngx-translate/core';
import { ApprovalsEquipmentsService } from 'app/main/approvals-equipments/services/approvals-equipments.service';
import * as moment from 'moment';
import { Subject } from 'rxjs';
import english from '../../../../i18n/en.json';
import spanish from '../../../../i18n/es.json';
import portuguese from '../../../../i18n/pt.json';

@Component({
  selector: 'tab-approvals-equipments',
  templateUrl: './tab-approvals-equipments.component.html',
  styleUrls: ['./tab-approvals-equipments.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TabApprovalsEquipmentsComponent implements OnInit {
  public approvalForm: FormGroup;
  public isExistingNumber = false;

  @Output() disableButtonApproval: Subject<boolean> = new Subject();

  constructor(
    @Inject(MAT_DIALOG_DATA) public approval: any,
    private fuseTranslationLoaderService: FuseTranslationLoaderService,
    private formBuilder: FormBuilder,
    private statusApprovalsPipe: StatusApprovalsPipe,
    private translateService: TranslateService,
    private approvalsEquipmentsService: ApprovalsEquipmentsService
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
  }
  async ngOnInit(): Promise<void> {
    this.approvalForm = this.formBuilder.group({
      name: [{ value: this.approval.equipment.name, disabled: true }, [Validators.required]],
      number: [{ value: this.approval.equipment.number, disabled: true }, [Validators.required]],
      qrCode: [{ value: this.approval.equipment.qrCode, disabled: true }, [Validators.required]],
      notes: [{ value: this.approval.equipment.notes, disabled: true }, [Validators.required]],
      company: [{ value: this.approval.company.name, disabled: true }, [Validators.required]],
      locationName: [{ value: this.approval.equipment.location.name, disabled: true }, [Validators.required]],
      locationSectorName: [{ value: this.approval.equipment.locationSector ? this.approval.equipment.locationSector.name  : '' , disabled: true }, [Validators.required]],
      locationEnvironmentName: [{ value: this.approval.equipment.locationEnvironment ? this.approval.equipment.locationEnvironment.name  : '' , disabled: true }, [Validators.required]],
      locationFormattedAddress: [{ value: this.approval.equipment.location.address.formattedAddress, disabled: true }, [Validators.required]],
      type: [{ value: this.approval.equipment.type.name, disabled: true }, [Validators.required]],
      approvalCreatedAt: [{ value: moment(this.approval.createdAt).format('DD/MM/YYYY HH:mm'), disabled: true }, [Validators.required]],
      approvalStatus: [{ value: this.statusApprovalsPipe.transform(this.approval.status), disabled: true }, [Validators.required]],
      equipmentStatus: [{ value: (this.approval.equipment.archived ? this.translateService.instant('APPROVALS_EQUIPMENTS.INACTIVE') : this.translateService.instant('APPROVALS_EQUIPMENTS.ACTIVE')), disabled: true }, [Validators.required]]
    });

    if (this.approval) {
      const existingEquipment = await this.approvalsEquipmentsService.searchEquipment(this.approval.equipment.number);

      if (existingEquipment) {
        this.isExistingNumber = true;
        this.disableButtonApproval.next(this.isExistingNumber);
      }
    }
  }
}
